import {computed} from 'vue';
import {useBaseUrl} from '~/composables/useBaseUrl';

export function useLinksFrom(origin: string) {
    const baseUrl = useBaseUrl();

    // TODO: use NuxtLink to navigate inside the app
    const urlToAdvancedSearch = computed(() =>
        baseUrl.resolve({
            path: '/s/advanced',
            query: {
                brief_origin: origin,
            },
        }),
    );

    return {
        urlToAdvancedSearch,
    };
}
